export const RESET = 'EXSBPRICEGROUP_LIST_RESET'
export const SET_ITEMS = 'EXSBPRICEGROUP_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPRICEGROUP_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPRICEGROUP_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPRICEGROUP_LIST_TOGGLE_LOADING'
